import BookPassengerItem from "./BookPassengerItem";

export function getOfferPassengerEntries(passengers) {
  return Object.entries(passengers || {}).flatMap(([type, obj]) =>
    Array.from({ length: obj.total }, () => ({ type, ...obj })),
  );
}

export default function BookPassengersList({
  offer,
  bookingData,
  data,
  bags,
  expands,
  setExpands,
  totalPassenger,
  onPassengerChange,
  onContactChange,
  onFillTestPassenger,
  onBagChange,
  onSeatChange,
  renderPassengerExtras,
}) {
  const passengerEntries = getOfferPassengerEntries(offer?.passengers);

  if (!passengerEntries.length) return null;

  return (
    <div>
      {passengerEntries.map(({ type }, index) => (
        <BookPassengerItem
          key={index}
          index={index}
          type={type}
          isExpanded={expands[index]}
          totalPassenger={totalPassenger}
          onExpandChange={setExpands}
          passengerData={data?.passengers?.[index]}
          onPassengerChange={onPassengerChange}
          onContactChange={onContactChange}
          onFillTestPassenger={onFillTestPassenger}
          offer={offer}
          bookingData={bookingData}
          bags={bags}
          onBagChange={onBagChange}
          onSeatChange={onSeatChange}
        >
          {renderPassengerExtras?.({
            index,
            type,
            passengerData: data?.passengers?.[index],
          })}
        </BookPassengerItem>
      ))}
    </div>
  );
}
